var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-topo-aside-box",staticStyle:{"padding":"0"}},[_c('TopoSelect',{attrs:{"current":_vm.service,"data":_vm.services},on:{"onChoose":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }